<template>
  <div class="examine-container" v-loading="loading">
    <div class="card-block card-info">
      <div class="card-block__title">开票信息</div>
      <div class="card-block-content">
        <div class="info-item" :class="{'info-item__textarea': info.type === 'textarea'}"
          v-for="info in invoiceList"
          :key="info.label">
          <div class="info-item__label">{{info.label}}</div>
          <div class="info-item__value">{{info.value}}</div>
        </div>
      </div>
    </div>
    <div class="card-block">
      <div class="card-block__title">营业执照</div>
      <div class="card-block-content">
        <div class="info-item info-item__file"
          v-for="info in licenseList"
          :key="info.label">
          <div class="info-item__img" v-if="info.type !== 'input'">
            <img :src="info.value" :alt="info.value" @click.stop="toggleFullImg(true)">
          </div>
          <template v-if="pageType === 'examine' && info.type === 'input'">
            <div>
              <div class="info-item__label">驳回原因</div>
              <div class="info-item__value">
                <count-area :value="info.value" @changeVal="updateReason"></count-area>
              </div>
            </div>
          </template>
        </div>

        <div class="info-item info-item__btn">
          <div class="info-item__value">
            <template v-if="pageType === 'examine'">
              <Button @click.stop="reject">驳回</Button>
              <Button type="primary" @click.stop="pass">通过</Button>
            </template>
            <template v-else>
              <Button type="primary" @click.stop="goBack">返回</Button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <full-diag :isShow="showFullImg" @close="toggleFullImg(false)">
      <div class="full-img-content">
        <img :src="licenseList[0] === undefined ? '' : licenseList[0].value" alt="">
      </div>
    </full-diag>
  </div>
</template>
<script>
import countArea from '@/components/countArea'
import fullDiag from '@/components/dialogs/fullDiag'
import { getReviewDetail, reviewReject, reviewAccepte } from '@/api/invoice'
import { formatText } from '@/utils/common'
export default {
  name: 'invoiceInfo',
  components: { fullDiag, countArea },
  data() {
    return {
      loading: false,
      invoiceList: [],
      licenseList: [],
      file: null,
      showFullImg: false
    }
  },
  computed: {
    pageType() {
      return this.$route.name === 'examineDetail' ? 'examine' : 'info'
    },
    pageTitle() {
      return this.$route.name === 'examineDetail' ? '审核' : '查看'
    },
    companyType() {
      return this.$route.params.type
    },
    invoiceId() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.$store.dispatch('setPage', {
      title: this.pageTitle,
      type: ' '
    })
    this.getInfo()
  },
  methods: {
    // 驳回
    reject() {
      if (!this.licenseList[1].value) {
        this.$Message.info('驳回原因不能为空')
        return
      }
      reviewReject({
        company_type: this.companyType,
        invoice_id: this.invoiceId,
        reason: this.licenseList[1].value
      }).then(res => {
        if (res.code === 0) {
          this.goBack()
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    // 通过
    pass() {
      reviewAccepte({
        company_type: this.companyType,
        invoice_id: this.invoiceId
      }).then(res => {
        if (res.code === 0) {
          this.goBack()
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    // 获取信息
    getInfo() {
      this.loading = true
      getReviewDetail({
        company_type: this.companyType,
        invoice_id: this.invoiceId
      }).then(res => {
        this.loading = false
        const { code, result } = res
        if (code === 0) {
          // this.invoiceList = [
          //   { label: '发票抬头', name: 'name', value: result.company_title },
          //   { label: '纳税类型', name: 'taxType', value: formatText(result.tax_type, ['', '一般纳税人', '小规模纳税人']) },
          //   { label: '开户银行', name: 'bank', value: result.bank_name },
          //   { label: '营业电话', name: 'phone', value: result.phone },
          //   { label: '税务登记号统一社会信用代码', name: 'code', value: result.tax_no },
          //   { label: '类型', name: 'type', value: result.type },
          //   { label: '开户银行帐号', name: 'bankAccount', value: result.bank_no },
          //   { label: '营业地址', name: 'address', value: result.address },
          //   { label: '有效期', name: 'date', value: result.validity },
          //   { label: '备注信息', name: 'addon', value: result.memo }
          // ]
          this.invoiceList = [
            { label: '发票类型', name: 'invoice_type', value: formatText(result.invoice_type, [' ', '增值税普通发票', '增值税专用发票']) },
            { label: '名称', name: 'name', value: result.company_title },
            { label: '纳税类型', name: 'taxType', value: formatText(result.tax_type, [' ', '一般纳税人', '小规模纳税人']) },
            { label: '税号', name: 'code', value: result.tax_no },
            { label: '开户行', name: 'bank', value: result.bank_name },
            { label: '账号', name: 'bankAccount', value: result.bank_no },
            { label: '地址', name: 'address', value: result.address },
            { label: '电话', name: 'phone', value: result.phone }
            // { label: '发票抬头', name: 'name', value: result.company_title },
            // { label: '纳税类型', name: 'taxType', value: formatText(result.tax_type, ['', '一般纳税人', '小规模纳税人']) },
            // { label: '开户银行', name: 'bank', value: result.bank_name },
            // { label: '营业电话', name: 'phone', value: result.phone },
            // { label: '税务登记号统一社会信用代码', name: 'code', value: result.tax_no },
            // { label: '类型', name: 'type', value: result.type },
            // { label: '开户银行帐号', name: 'bankAccount', value: result.bank_no },
            // { label: '营业地址', name: 'address', value: result.address },
            // { label: '有效期', name: 'date', value: result.validity },
            // { label: '备注信息', name: 'addon', value: result.memo }
          ]
          this.licenseList = [
            { label: '税务登记证', name: 'license', value: result.tax_photo },
            { label: '驳回原因', name: 'reason', value: '', type: 'input' } // 驳回原因写死为空
          ]
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    // 开大图
    toggleFullImg(flag) {
      this.showFullImg = flag
    },
    updateReason(val) {
      this.licenseList[1].value = val
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss">
  @import "@/styles/card.scss";
  .examine-container {
    margin: -20px 0;
  }
</style>
<style lang="scss" scoped>
  @import "@/styles/card.scss";
  .card-block {
    margin: 0;
  }
  .card-block__title {
    margin: 0 0 20px 0;
  }
  .card-info {
    .card-block-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .info-item + .info-item {
      margin-bottom: 20px;
      margin-top: 0;
    }
    .info-item {
      width: 50%;
      // margin: 0 !important;
      margin-bottom: 20px;
    }
    .info-item__label {
      position: relative;
      width: 90px;
    }
    .info-item__value {
      width: auto;
      padding: 0;
    }
  }
</style>
